import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import Error from '../component/ErrorDispaly.js';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SecureShow from '../component/SecureShow';
import TableRow from '../component/TableRow';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import { AppSetting, AppProperties } from '../common/function';
import SFTooltip from './AssignmentMatrix/components/SFTooltip.jsx';
import SFInfoTooltip from './AssignmentMatrix/components/SFInfoTooltip.jsx';
import { AppContext } from '../component/context/AppContext';
import HelpText from '../lib/help-text.js';
import SFSemesterDropdown from '../component/SFSemesterDropdown.jsx';
import { Tooltip, Typography } from '@mui/material';
import { BsInfoCircleFill } from "react-icons/bs";
import { BeatLoader } from 'react-spinners';

const MIN_COURSE_CODE_LENGTH = 8;
const MAX_COURSE_CODE_LENGTH = 15;

let course = {
  course_name: '',
  course_id: '',
  is_lti_enabled:""
};
export default class Courses extends Component {
  AppSetting = AppSetting();
  appProperties = AppProperties();

  helpTextModel = new HelpText();

  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      courses: [],
      temp_course: course,
      temp_id: '',
      visible: false,
      addMode: true,
      errorMessage: '',
      errorType: '',
      loading:true,
      generateCodeLoading: false,
      selectedSemester: null,
    };

    this.deleteCourse = this.deleteCourse.bind(this);
    this.addCourse = this.addCourse.bind(this);
    this.changeCourseName = this.changeCourseName.bind(this);
    this.changeCourseCode = this.changeCourseCode.bind(this);
    this.updateCourse = this.updateCourse.bind(this);
    this.isEnterPressed = this.isEnterPressed.bind(this); 
    this.ltiEnable = this.ltiEnable.bind(this);
  }

  componentWillMount() {
    this.getAllCourses(0); 
  }

  getAllCourses = (semesterID) => {
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/getAllCourses',
      data: {
        id: semesterID,
      }
    }).then(res => {
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      } else if (res.data === '') {
        NotificationManager.error('Connection Problem', 'ERROR', 3000);
      }

      console.debug('course response ', res);
      
      if (res.data && res.data.data && res.data.data.course_names != null) {
        this.setState({
          courses: res.data.data.course_names
        });
     } else {
      this.setState({
          courses: []
        });
     }
    }).finally(() => {
      this.setState({
        loading: false,
      })
    });
  }
  
  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
      { name: (this.appProperties.schoolMode?'All Standards':'All Courses'), type: '', onclickPath: '/courses' }
    ]);
  };

  ltiEnable(courseType,id) {
    const payload = {
      course_id: courseType.course_id,
      is_lti_enabled: !courseType.is_lti_enabled
    };


    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/enableLTICourse',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug(res);
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
      //window.localtion.reload();
      if (res.data.data != null) {
        //this.state.courses[this.state.temp_id] = payload
        let tempCourse = this.state.courses;
        tempCourse[id].is_lti_enabled = !tempCourse[id].is_lti_enabled
        tempCourse[id].status = 1;
        this.setState({
          courses: tempCourse
        });
      }
      }
    });
  }

  handleUpdateCourseStatus = (course, id) => {
    const payload = {
      course_id: course.course_id,
      status: course.status === 0 ? 1 : 0
    };
    console.debug("payload>>>>>", payload)

    this.setState({
      loading:true
    });

    const response = ApiRequestService({
      method: 'POST',
      url: '/updateCourseStatus',
      data: payload
    })

    response.then(res => {
      console.debug("res", res)
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
      if (res.data.data != null) {
        let tempCourse = this.state.courses;
        tempCourse[id].status = payload.status;
        console.debug(" tempCourse[id]",  tempCourse[id])
        this.setState({
          courses: tempCourse
        });
      }
      }
    }).finally(() => {
      this.setState({
        loading: false
      });
    })

  }

  handleCourseVisibility = (isPublic, course, id) => {
    const payload = {
      course_id: course.course_id,
      is_public: isPublic,
    };

    this.setState({
      // loading:true
    });

    const response = ApiRequestService({
      method: 'POST',
      url: '/updateCourseVisibility',
      data: payload
    })

    response.then(res => {
      console.debug("res", res)
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
      if (res.data.data != null) {
        let tempCourse = [...this.state.courses];
        tempCourse[id].is_public = payload.is_public;
        this.setState({
          courses: tempCourse
        });
        let msg = "Course visibility changed to private."
        if (payload.is_public === 1) {
          msg = "Course visibility changed to public."
        }
        NotificationManager.success(msg, "", 3000);
      }
      }
    }).finally(() => {
      this.setState({
        // loading: false
      });
    })

  }

  componentWillUpdate() {
    this.addBreadCrumbs();
  }
  componentWillUnmount() {
    this.removeBreadCrumbs();
  }




  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };


  addCourse() {
    console.debug('Add course :' + this.state.temp_course.course_name);
    const payload = {
      course_name: this.state.temp_course.course_name,
      code: this.state.temp_course.code,
    };

    if (this.context?.isPublicSite) {
      // check if course code is valid, 8 letters
      if (!payload.code || payload.code.length < MIN_COURSE_CODE_LENGTH) {
        NotificationManager.error("Code must be between 8 and 15 characters.”", "", 3000);
        return;
      }
    }

    if (!payload.course_name || payload.course_name.length < 0) {
      NotificationManager.error("Course name cannot be empty", "", 3000);
      return;
    }

    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/addCourse',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug('Add course response : ', res);
      console.debug('Add course response : ', res.data.message);
      var tempCourse = this.state.courses;
      if (res.data.message !== null && res.data.message !== '') {
        if (res.data.message === 'Duplicate Course entry!') {
          NotificationManager.error("Course with this name already exists. Please give a different name", 'Duplicate Entry', 5000);
        } else if (res.data.message === "course code exists") {
          NotificationManager.error("Course code already exists. Please try a different code", 'Code Exists', 5000);
        } else {
           NotificationManager.error(res.data.message, 'ERROR', 5000);
        }
        return;
      }
      if (res.data.data != null) {
        tempCourse.push({
          course_name: res.data.data.course_name,
          code: res.data.data.code,
          is_public: res.data.data.is_public,
          course_id: res.data.data.course_id,
          status: res.data.data.status,
          is_lti_enabled: res.data.data.is_lti_enabled,
          created_by: res.data.data.created_by,
          created_at: res.data.data.created_at
        });
        this.setState({
          courses: tempCourse,
          loading:false
        });
      }
      this.hide();

      const msg = `Successfully created your "${res.data.data.course_name} course."`
      NotificationManager.success(msg, "", 3000);

      // Redirect the user to sections list page
      const url = 'sections?course_id=' +
                        res.data.data.course_id +
                        '&course_name=' +
                        res.data.data.course_name +
                        '&is_lti_enabled=' +
                        res.data.data.is_lti_enabled +
                        '&is_new=true' +
                        '&is_current_semester=true' +
                        '&semester_id=' +
                        this.state.selectedSemester?.id +
                        '&semester_name=' +
                        this.state.selectedSemester?.label
      browserHistory.push(this.appProperties.baseFolder + url);
    });
  }

  editCourse(id) {
    this.setState({
      temp_course: {...this.state.courses[id]},
      temp_id: id,
      addMode: false
    });
    this.show(false);
  }

  updateCourse() {
    console.debug('Editing course :' + this.state.temp_course.course_id);

    const payload = this.state.temp_course;

    if (this.context?.isPublicSite) {
      // check if course code is valid, 8 letters
      if (payload.code === "" || payload.code.length < MIN_COURSE_CODE_LENGTH) {
        NotificationManager.error("Code must be between 8 and 15 characters.”", "", 3000);
        return;
      }
    }

    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/updateCourse',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug(res);
      if (res.data.message !== null && res.data.message !== '') {
        if (res.data.message === 'Duplicate Course entry!') {
          NotificationManager.error("Course with this name already exists. Please give a different name", 'Duplicate Entry', 5000);
        } else if (res.data.message === "course code exists") {
          NotificationManager.error("Course code already exists. Please try a different code", 'Code Exists', 5000);
        } else {
           NotificationManager.error(res.data.message, 'ERROR', 5000);
        }
        return;
      }

      if (res.data.data != null) {
        //this.state.courses[this.state.temp_id] = payload
        const newCourses = this.state.courses.map((c, idx) =>
          idx === this.state.temp_id ? { ...c, ...payload } : c
        );
        console.debug('UpdateCourse State: ', newCourses);
        this.setState({
          courses: newCourses,
          temp_course: course
        });
      }
      this.hide();
    });
  }
  deleteCourse(id) {
    console.debug(
      'Deleting course i:' + id + ' id: ' + this.state.courses[id].course_id
    );
    const payload = {
      course_id: this.state.courses[id].course_id
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/deleteCourse',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug(res);
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
      //window.localtion.reload();
        this.state.courses.splice(id, 1);
        console.debug('Spliced Array', this.state.courses);
        this.setState({
          courses: this.state.courses
        });
      }
    });
  }
  changeCourseName(event) {
    let curCourseName = this.state.temp_course;
    curCourseName.course_name = event;
    this.setState({
      temp_course: curCourseName
    });
  }

  changeCourseCode(value) {
    if (value && value.length > MAX_COURSE_CODE_LENGTH) return;
    let curCourse = this.state.temp_course;
    curCourse.code = value;
    this.setState({
      temp_course: curCourse
    });
  }

  show = isCourseEnable => {
    if (isCourseEnable) {
      this.setState({
        temp_course: {
          course_name: '',
          course_id: ''
        }
      });
    }
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };
  subjPage() {
    browserHistory.push( this.appProperties.baseFolder + 'courses');
  }
  delete = id => {
    confirmAlert({
      title: 'Are you sure want to delete this course?',
      message: 'Press Confirm to submit',

      confirmLabel: 'Cancel',
      cancelLabel: 'Confirm',
      onCancel: () => this.deleteCourse(id)
      //   onCancel: () => ,
    });
  };

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
      this.addCourse();
    } else{
      this.updateCourse();
    }
  }
  }

  generateCode = () => {
    this.setState({generateCodeLoading: true});
    ApiRequestService({
      method: 'get',
      url: '/generateCourseCode',
    }).then(res => {
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      } else {
        this.setState({
          temp_course: {
            ...this.state.temp_course,
            code: res.data.data,
          }
        });
      }
    }).finally(() => {
      this.setState({generateCodeLoading: false});
    })
  }

  handleSemesterChange = (semester) => {
    this.setState({ selectedSemester: semester });
    this.getAllCourses(semester.id);
  }

  render() {
    let button = null;
    if (this.state.addMode) {
      button = (
        <Button style={styles.addButton} 
        disabled={this.state.course_name === ""}
        autoFocus onClick={this.addCourse}>
          {this.appProperties.schoolMode?"Add Standard":"Add Course"}
        </Button>
      );
    } else {
      button = (
        <Button style={styles.addButton} autoFocus onClick={this.updateCourse}>
         {this.appProperties.schoolMode?"Update Standard":"Update Course"}
        </Button>
      );
    }
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);

  // role/access gating for Add button
  const ADMIN_ROLE_ID = 2;
  const roleID = parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10) || 0;
  const instructorCourseCreationAccess = parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_courseCreationAccess`), 10) || 0;
  let canAddCourse = (roleID === ADMIN_ROLE_ID || instructorCourseCreationAccess === 1);
  let addCourseBtnDisabled = false;
  if (this.state.selectedSemester && this.state.selectedSemester.data.isCurrent === false) {
    addCourseBtnDisabled = true
  }

  return (
      <SecureShow targetRole={1}>
        <div>
          <div className='course-page-semester-dropdown'>
            <div style={{width:"300px"}}>
              <SFSemesterDropdown 
                selectedSemester={this.state.selectedSemester}
                onChange={semester => {
                  this.handleSemesterChange(semester);
                }}
              />
            </div>
            <Tooltip
                  title={<Typography className='text-white' fontSize={14}>
                      You can select any semester, but only the current semester can be edited. The current semester can be changed in Settings.
                  </Typography>}
                  placement={'right'}
                  arrow
              >
                  <span>
                      <BsInfoCircleFill color='#737373' size={14}
                          style={{
                              flexShrink: 0,
                              minWidth: "12px",
                              minHeight: "12px",
                              verticalAlign: "middle",
                              cursor: "pointer",
                          }} />
                  </span>
              </Tooltip>
          </div>
          <div style={styles.courseTitle} className="courseContainerDiv">
          {this.appProperties.schoolMode
          ? "Standards"
        : "Courses"
        }

            {canAddCourse ? (
            <div style={styles.floatRight}>
            <Button 
            disabled={addCourseBtnDisabled}
            style={styles.courseAddButton} className="archive-button" primary raised
                onClick={() => this.show(true)}>
                  Add a New Course
              </Button>
            </div>
          ) : (
                ''
        )}
          </div>
          {
            <DialogContainer
              id="simple-action-dialog"
              width="500px"
              visible={this.state.visible}
              onHide={this.hide}
              actions={actions}
              closeOnEsc={false}
              modal
              title={this.appProperties.schoolMode?"New Standard":"New Course"}
            >
{/*               <input
                type="text"
                name="course_name"
                defaultValue={this.state.temp_course.course_name}
                onChange={this.changeCourseName}
                onKeyPress={this.isEnterPressed.bind(this)}
              /> */}
              <TextField 
                 name="course_name"
                 value={this.state.temp_course.course_name}
                 onChange={this.changeCourseName}
                 onKeyPress={this.isEnterPressed.bind(this)}
                 placeholder='Enter course name'
                 className="md-cell md-cell--12"
                />
              {this.context?.isPublicSite ? 
                <React.Fragment>
                  <div style={{ display: 'flex', justifyContent:'flex-start', alignItems:'center',gap:'2px' }}>
                    <div>
                      <SFInfoTooltip
                        tooltipText={
                          "This unique code is required for students to enroll in and access this course."
                        }
                        placement='left'
                      />
                      </div>
                    <div style={{width:"65%"}}>
                      <TextField
                        style={{
                          marginTop: '2rem',
                          width:'100%'
                        }}
                        name="code"
                        value={this.state.temp_course.code}
                        onChange={this.changeCourseCode}
                        onKeyPress={this.isEnterPressed.bind(this)}
                        placeholder='Enter course code'
                        className="md-cell md-cell--12"
                      //  maxLength={10}
                      />
                      <div style={{ fontSize: '0.8rem', color: '#888', textAlign: 'right', marginTop: '0.25rem' }}>
                        {this.state.temp_course?.code?.length ? this.state.temp_course?.code?.length : 0} / {MAX_COURSE_CODE_LENGTH}
                      </div>
                    </div>
                    <Button primary raised
                    onClick={this.generateCode}
                    >Generate Code</Button>
                  </div>
                </React.Fragment>
            : null}
            </DialogContainer>
          }
          {this.state.loading ? 
            <div style={{display:'flex', justifyContent:"center", alignItems:'center', marginTop:'8rem'}}>
              <BeatLoader size={15} loading={true} color='#bb0000' />
            </div>
          :
          <table style={styles.courseTable} className="courseTable">
            <thead style={styles.thead}>
              <tr>
                <th>ID</th>
                {this.appProperties.schoolMode
                  ?
                    <th>Standard</th>
                  :
                    <th>Course Name</th>
                }
                {this.context?.isPublicSite ? <th>
                  <SFInfoTooltip 
                    name="Code"
                    tooltipText={this.helpTextModel.getHelpTextForKey('Course Code')}
                  />
                </th> : null}
                <th>Created At</th>
                <th>Created By</th>
                {this.context?.isPublicSite ? null : <th>LTI Course</th>}
                <th>
                  <SFInfoTooltip 
                    name="Publish/Unpublish"
                    tooltipText="Publish/Unpublish"
                  />
                </th>
                {this.context?.isPublicSite ? <th>
                  <SFInfoTooltip 
                    name="Visibility"
                    tooltipText={this.helpTextModel.getHelpTextForKey('Course Visibility')}
                  />
                </th> : null}
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {this.state.courses && this.state.courses.length
                ? this.state.courses.map((course, i) => (
                    <TableRow
                      key={i}
                      data={course}
                      id={course.course_id}
                      name={course.course_name}
                      created_at={course.created_at}
                      created_by={course.created_by}
                      timezone={this.appProperties.currentUserData.timeZone}
                      title={this.appProperties.schoolMode?'Standards':'Courses'}
                      username={this.appProperties.currentUserData.USER_NAME}
                      type={''}
                      url={
                        'sections?course_id=' +
                        course.course_id +
                        '&course_name=' +
                        course.course_name +
                        '&is_lti_enabled=' +
                        course.is_lti_enabled +
                        '&semester_id=' +
                        this.state.selectedSemester?.id +
                        '&semester_name=' +
                        this.state.selectedSemester?.label +
                        '&is_current_semester=' +
                        this.state.selectedSemester?.data?.isCurrent
                      }
                      onLTICourseChange={() => this.ltiEnable(course,i)}
                      handleUpdateCourseStatus={() => this.handleUpdateCourseStatus(course, i)}
                      handleCourseVisibility={(isPublic) => this.handleCourseVisibility(isPublic, course, i)}
                      onEditClick={() => this.editCourse(i)}
                      pushId={'course'}
                      onDeleteClick={() => this.delete(i)}
                      instructorSubject = {true}
                      isLtiCourse={course.is_lti_enabled}
                      status={course.status}
                      disableActionButtons={this.state.selectedSemester?.data?.isCurrent === false}
                      // disableActionButtons={true}
                    />
                  ))
                : 

                (this.state.loading ? null : 
                <div style={{
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center",
                  marginTop:"1.2rem",
                  color:"#555",
                  position:"absolute",
                  width:'100%',
                }}>
                  No Courses available.
                </div>)
               
                }
            </tbody>
          </table>
          }

          <Error
            type={this.state.errorType}
            message={this.state.errorMessage}
          />
        </div>
      </SecureShow>
    );
  }
}
